<template>
  <a-button
    icon="save"
    size="small"
    type="link"
    @click="e => $emit('click', e)"
    style="color: #faad14"
  >
    保存
  </a-button>
</template>

<script>
export default {
  name: 'SaveButton'
}
</script>
